module.exports = __webpack_public_path__ + "static/img/waterPump.5d479177.png";